import { render, staticRenderFns } from "./DeviceManagementSetting.vue?vue&type=template&id=2f220774&scoped=true"
import script from "./DeviceManagementSetting.vue?vue&type=script&lang=js"
export * from "./DeviceManagementSetting.vue?vue&type=script&lang=js"
import style0 from "./DeviceManagementSetting.vue?vue&type=style&index=0&id=2f220774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f220774",
  null
  
)

export default component.exports